

exports.__esModule = true;
exports.$registerDirective = $registerDirective;
var _angular = _interopRequireDefault(require("angular"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function $registerDirective(tag, definition) {
  var directiveName = tag.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  return _angular["default"].module().directive(directiveName, definition);
}
_angular["default"].value("$registerDirective", $registerDirective);


//////////////////
// WEBPACK FOOTER
// ../node_modules/squid/dist/ng/directive.js
// module id = ../node_modules/squid/dist/ng/directive.js
// module chunks = 0